import {REPORT_NOT_CERTIFIED} from '/enum/records.enum';

export default {
  reportName: REPORT_NOT_CERTIFIED,
};
